var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"domain-cell"},[_c('div',{staticClass:"content-domain-and-asset"},[_c('div',{staticClass:"domain-value",attrs:{"domain":_vm.domain}},[_vm._v(" "+_vm._s(_vm.domain)+" ")]),_c('div',{staticClass:"asset-value",attrs:{"title":_vm.asset}},[_vm._v(" "+_vm._s(_vm.asset)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }